import Bugsnag, { Client } from '@bugsnag/js';

function startBugsnag(): Client | null {
  if (window?.Bugsnag) {
    return window.Bugsnag as Client;
  }

  // Bugsnag.start() will be called in all Rails server environments as long as NODE_ENV is set for production.
  if (process.env.NODE_ENV !== 'production') {
    console.warn('useBugsnag: not starting Bugsnag as this is not a NODE_ENV=production build');
    return null;
  }

  const store = global.__AT_STORE__;

  if (!store) {
    console.warn('useBugsnag: not starting Bugsnag as the global store is not defined');
    return null;
  }

  Bugsnag.start({
    apiKey: store.BUGSNAG_KEY,
    appVersion: store.BUILD_DATE,
    releaseStage: store.RAILS_ENV
  });

  window.Bugsnag = Bugsnag;

  return Bugsnag;
}

function getBugsnag() {
  return window?.Bugsnag;
}

export { startBugsnag, getBugsnag };
